import { render, staticRenderFns } from "./simple-modal.vue?vue&type=template&id=3e99382c"
import script from "./simple-modal.vue?vue&type=script&lang=js"
export * from "./simple-modal.vue?vue&type=script&lang=js"
import style0 from "./simple-modal.vue?vue&type=style&index=0&id=3e99382c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports